// This is a constant used by the pcdb data selector component.

export const PCDBLOOKUPS = {
  mainTypes: {
      gasOilBoiler: {
          '0': 'Not Known',
          '1': 'Regular',
          '2': 'Combi',
          '3': 'CPSU'
      },
      solidFuelBoiler: {
          '1': 'Open fire with boiler',
          '2': 'Closed room heater with boiler',
          '3': 'Independent boiler'
      },
      cookerBoiler: {
          '1': 'Cooker boiler with separately controller twin burners'
      },
      heatPump: {
          '1': 'Wet system, flow temperature 55°C',
          '2': 'Wet system, flow temperature 45°C',
          '3': 'Wet system',
          '4': 'Warm air system'
      },
      warmAir: {
          '0': 'Unknown',
          '1': 'Floor',
          '2': 'Wall',
          '3': 'Either floor or wall'
      },
      electricStorageHeaters: {
          '0': 'Not high heat retention',
          '1': 'High heat retention'
      },
      heatingControls: {
          '1': 'Weather and/or load compensation',
          '2': 'Time and temperature zone control',
          '3': 'Weather and/or load compensation + Time and temperature zone control'
      },
      fghrsIndexes: {
          'C': 'Instantaneous combi without keep-hot facility and without external store',
          'E': 'Instantaneous combi close-coupled external store',
          'K': 'Instantaneous combi with keep-hot facility',
          'P': 'CPSU',
          'R': 'Regular boiler',
          'S': 'Storage combi'
      },
      wwhrsIndexes: {
          'A': 'Shower and boiler',
          'B': 'Shower only',
          'C': 'Boiler only'
      }
  },
  condensing: {
      default: {
          '0': 'Not known',
          '1': 'Non-condensing',
          '2': 'Condensing'
      },
      fghrsIndexes: {
          '0': 'No PV',
          '1': 'Has PV',
          '2': 'Heat store'
      }
  },
  flueTypes: {
      default: {
          '0': 'Unknown',
          '1': 'Open',
          '2': 'Balanced',
          '3': 'Open or balanced',
          '4': 'Open chimney'
      },
      heatPump: {
          '0': 'Unknown',
          '1': 'Open',
          '2': 'Balanced',
          '3': 'Open or balanced',
          '4': 'None'
      }
  },
  fanAssisted: {
      '0': 'Unknown',
      '1': 'No',
      '2': 'Yes'
  },
  heatSources: {
      heatPump: {
          '1': 'Ground',
          '3': 'Air',
          '4': 'Exhaust air MEV',
          '5': 'Exhaust air MVHR',
          '6': 'Mixed exhaust air MEV and outside are',
          '7': 'Ground water',
          '8': 'Surface water',
          '9': 'Solar assisted'
      },
      communityHeating: {
          '1': 'CHP',
          '2': 'Boiler',
          '3': 'Heat pump',
          '4': 'Waste heat from power station',
          '5': 'Geothermal'
      },
      fghrsIndexes: {
          '1': 'No store',
          '2': 'Internal store',
          '3': 'Close-coupled external store'
      }
  }
};
